import { Field, useFormikContext } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import { Checkbox, TextField } from "formik-mui";
import MuiTextField from "@mui/material/TextField";
import React from "react";
import { FormHelperText, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";

export const RequoteForm = () => {
  const { handleSubmit, values } = useFormikContext();
  const { mode, baseRate, addonRate } = values;
  return (
    <Form onSubmit={handleSubmit}>
      <Stack spacing={3} alignItems="start">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Field
            component={TextField}
            name="costOfVessel"
            label="Cost of Vessel"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
              inputProps: {
                step: "500",
              },
            }}
            margin="none"
          />
          <Typography variant="h3" component="span" sx={{ mx: 2 }}>
            -
          </Typography>
          <Field
            component={TextField}
            name="deposit"
            label="Deposit"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
              inputProps: {
                step: "500",
              },
            }}
            margin="none"
          />
          <Typography variant="h3" component="span" sx={{ mx: 2 }}>
            =
          </Typography>

          <MuiTextField
            label="Principal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
            }}
            disabled
            value={values.costOfVessel - values.deposit}
            margin="none"
          />
        </div>
        <div>
          <Field
            component={TextField}
            name="addonRate"
            label="Addon Rate"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              type: "number",
              inputProps: {
                step: "0.1",
              },
            }}
            margin="none"
            disabled={values.lookupRate}
          />{" "}
          <MuiTextField
            margin="none"
            sx={{ ml: 2 }}
            disabled
            label="Blended Rate"
            value={`+ ${baseRate}% = ${baseRate + addonRate}%`}
          />
          <br />
          <FormControlLabel
            control={
              <Field component={Checkbox} type="checkbox" name="lookupRate" />
            }
            label="Lookup rate in matrix"
          />{" "}
          <FormHelperText>
            Addon rate will be determined based on loan amount and boat type
            using the current matrix values.
          </FormHelperText>
        </div>
        <div>
          <Field
            component={TextField}
            name="balloon"
            label="Balloon"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
              inputProps: {
                step: "500",
              },
            }}
            margin="none"
          />
          <FormHelperText>
            Optional larger final instalment. A balloon makes the loan
            fixed-rate. Leave blank/0 for a standard amortising loan.
          </FormHelperText>
        </div>
        {/*<Field component={ToggleButtonGroup} name="mode" type="checkbox" exclusive={true}>*/}
        {/*  <ToggleButton value="term">Fixed Term</ToggleButton>*/}
        {/*  <ToggleButton value="payment">Fixed Payment</ToggleButton>*/}
        {/*</Field>*/}
        {mode === "term" && (
          <Field
            component={TextField}
            name="term"
            label="Term"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">months</InputAdornment>
              ),
              type: "number",
            }}
            margin="none"
          />
        )}
        {mode === "payment" && (
          <Field
            component={TextField}
            name="repayment"
            label="Monthly Payment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
            }}
            margin="none"
          />
        )}
        <div>
          <FormControlLabel
            margin="none"
            control={
              <Field component={Checkbox} type="checkbox" name="ignoreLimits" />
            }
            label="Ignore Limits"
          />
          <FormHelperText>
            Overrides min/max for term, principal and deposit ratio
          </FormHelperText>
        </div>
        <div>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            margin="normal"
            sx={{ mt: 1 }}
          >
            Preview
          </Button>
        </div>
      </Stack>
    </Form>
  );
};
